import React, { useCallback, memo } from 'react';
import * as Styled from './styled';
import { Select, SelectOption } from '@leasequery/lq.react-component-library';
import { REPORT_CURRENCY_SELECT_OPTIONS } from '../../../constants';
import { ReportCurrency } from '../../../models';
import { Icon } from '../../../components';
import { CurrencySelectorWrapper } from '../../../components';

interface ReportSettingCustomProps {
  onChange: (updatedValue: ReportSettingCustomState) => void;
  reportSettingState: ReportSettingCustomState;
}

export interface ReportSettingCustomState {
  selectedCurrency: SelectOption<ReportCurrency>;
  isValid: boolean;
  reportDate: string;
}

function ReportSettingCustom({
  onChange,
  reportSettingState,
}: ReportSettingCustomProps): JSX.Element {
  return (
    <>
      <CurrencySelectorWrapper>
        <Styled.DropdownBar>
          <div>
            <Icon name="currency" />
          </div>
          <Select
            placeholder="Local currency"
            label="Currency"
            name="currency"
            options={REPORT_CURRENCY_SELECT_OPTIONS}
            onChange={useCallback(
              (option: SelectOption<ReportCurrency>): void => {
                onChange({
                  ...reportSettingState,
                  selectedCurrency: option,
                });
              },
              [onChange, reportSettingState],
            )}
            value={reportSettingState.selectedCurrency}
          />
        </Styled.DropdownBar>
      </CurrencySelectorWrapper>
      <Styled.Line />
    </>
  );
}

export default memo(ReportSettingCustom);
